import openWindow from '@/script/openWindow.mjs'

export const aiGenerateAam = () => () => {
    return async function () {
        const {prjId, sVer} = this.data

        openWindow(
            '/Ai',

            {
                prjId,
                scene: 'GENERATE_AAM',
                sVer,
            }
        )
    }
}
